import { Button, Snackbar, styled } from "@mui/material";

// Styled Snackbar component
export const StyledSnackbar = styled(Snackbar)(({ theme }) => ({
  "& .MuiSnackbarContent-root": {
    backgroundColor: "#fff",
    color: "#000",
    minWidth: "auto",
    padding: theme.spacing(1, 2),
    boxShadow: theme.shadows[3],
    borderRadius: theme.shape.borderRadius,
  },
  "& .MuiSnackbarContent-message": {
    padding: 0,
    fontSize: theme.typography.body2.fontSize,
  },
  "& .MuiSnackbarContent-action": {
    paddingLeft: theme.spacing(2),
  },
}));

// Styled close button
export const CloseButton = styled(Button)(({ theme }) => ({
  minWidth: "auto",
  padding: theme.spacing(0.5),
  color: theme.palette.grey[600],
  "&:hover": {
    backgroundColor: "transparent",
    color: theme.palette.grey[900],
  },
}));
